
import Vue from "vue";

// Load every component from ../components/stations/
const req = require.context("../components/stations/", false, /\.(js|vue)$/i);
for (const key of req.keys()) {
  const name = key.match(/\w+/) ?? [0];
  Vue.component("station-" + name, req(key).default);
}

export default Vue.extend({
  name: "Station",
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data: function() {
    return {
      informationIds: [
        2391566500,
        2511510500,
        2549523210,
        2589535410,
        2619521210,
        2649525000,
        2691510700
      ]
    };
  }
});
